<template>
    <Layout>
        <div class="row justify-content-center">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="card bg-pattern">
                    <div class="card-body p-4">
                        <div class="text-center w-75 m-auto mb-4">
                            <a href="/">
                                <span><img alt="" height="22" src="@assets/images/logo-dark.png"/></span>
                            </a>
                          <p class="text-muted mb-4 mt-3">
                            First time login, you have to change your password, unless you change the password you can not use this application.
                          </p>
                        </div>

                        <div class="alert alert-danger alert-dismissible fade show"
                                role="alert"
                             v-show="show">
                        <span :key="index" v-for="(err, index) in validation_errors">
                          {{ err[0] }} <br/>
                        </span>
                        </div>

                        <form action="">
                            <b-form-group
                                    id="input-group-2"
                                    label="Password"
                                    label-for="input-2">
                                <b-form-input type="password" v-model="pass.password"
                                        id="input-2" name="password" ref="password" required placeholder="Password">
                                </b-form-input>
                                <div class="invalid-feedback">
                                    Password is required.
                                </div>
                            </b-form-group>
                            <b-form-group id="input-group-1" label="Confirm Password" label-for="input-1">
                                <b-form-input type="password" v-model="pass.password_confirmation"
                                        id="input-1"
                                        name="confirm_password"
                                        placeholder="Confirm password"
                                        required></b-form-input>
                                <div class="invalid-feedback">
                                    Confirm password is required and Confirm password is not
                                    match.
                                </div>
                            </b-form-group>
                            <b-form-group class="mt-4" id="button-group">
                                <b-button class="btn-block" variant="primary"  @click.prevent="UpdatePassword()">Update Password</b-button>
                            </b-form-group>
                        </form>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card -->
                <!-- end row -->
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </Layout>
</template>
<script>
    import Layout from "@layouts/auth";
    import {authMethods} from "@state/helpers";
    import appConfig from "@src/app.config";
    import http from "@state/http";

    export default {
        page: {
            title: "Update Password",
            meta: [{name: "description", content: "Update Password"}]
        },
        components: {Layout},
        data() {
            return {
                pass: {
                    password: "",
                    password_confirmation: ""
                },
                validation_errors: {},
                show: false
            };
        },

        methods: {
            UpdatePassword() {
                http
                    .post("api/update-password", this.pass)
                    .then(response => {
                         this.$router.push(this.$route.query.redirectFrom || {name: "home"});
                    })
                    .catch(error => {
                        this.validation_errors = error.response.data.errors;
                        this.show = true;
                        this.hide();
                    });
            },
            hide() {
                setTimeout(() => {
                    this.show = false;
                }, 5000);
            },
        },
        mounted() {
            history.pushState(null, null, location.href);
            window.onpopstate = function () {
                history.go(1);
            };
        }
    };
</script>
<style lang="scss" module></style>
